import React, { Component } from 'react';
import { Button, Modal, Form, Message } from 'semantic-ui-react'

import { getRiskColumnsByLanguage, getInstanceConfig, getText } from '../../helpers'

import './index.css'

class ExportModal extends Component {
  constructor(props){
    super(props);

    const plan_ids = props.plans ? props.plans.map((plan) => { return plan.id }) : [];

    this.state = {
      columns: [],
      plan_ids: plan_ids
    }

    const { risk_matrix: riskMatrix = '5x5' } = getInstanceConfig();
    this.isFiveByFiveMatrix = riskMatrix === '5x5';
  }

  componentDidMount = () => {
    this.onSelectAll();
  }

  componentWillReceiveProps = (nextProps) => {
    if(this.props.pending !== nextProps.pending && !nextProps.pending && !nextProps.isExportFailed) {
      this.props.onClose()
    }
    if (nextProps.shown && this.props.shown !== nextProps.shown) {
      this.onSelectAll();
    }
  }

  getExportOptions = () => {
    if (this.isFiveByFiveMatrix) return this.getFiveByFiveExportOptions();
    return this.getSixBySixExportOptions();
  }

  getFiveByFiveExportOptions = () => {
    const { languageName } = this.props
    const riskColumns = getRiskColumnsByLanguage(languageName);
    return [
      {
        dataField: riskColumns.work_phase,
        text: getText("Work Phase or Ambient Exposure")
      },
      {
        dataField: riskColumns.activity,
        text: getText("Activity")
      },
      {
        dataField: riskColumns.hazard,
        text: getText("Hazard (Risk Source)")
      },
      {
        dataField: riskColumns.unwanted_event,
        text: getText("(Unwanted) Event")
      },
      {
        dataField: 'existing_preventative',
        text: getText("Existing Preventative Controls")
      },
      {
        dataField: 'existing_recovery',
        text: getText("Existing Recovery Controls")
      },
      {
        dataField: 'likelihood',
        text: getText("Likelihood of Unwanted Event")
      },
      {
        dataField: 'consequences_description',
        text: getText("Consequence (text description)")
      },
      {
        dataField: 'financial',
        text: getText("Financial")
      },
      {
        dataField: 'safety',
        text: getText("Safety")
      },
      {
        dataField: 'health',
        text: getText("Occ. Health")
      },
      {
        dataField: 'reputation',
        text: getText("Reputation")
      },
      {
        dataField: 'environmental',
        text: getText("Environment")
      },
      {
        dataField: 'legal',
        text: getText("Legal")
      },
      {
        dataField: 'community',
        text: getText("Community")
      },
      {
        dataField: 'current_risk_rating',
        text: getText("Residual (Current) Risk Rating")
      },
      {
        dataField: 'additional_preventative',
        text: getText("Additional Preventative Controls")
      },
      {
        dataField: 'additional_recovery',
        text: getText("Additional Recovery Controls")
      },
      {
        dataField: 'new_likelihood',
        text: getText("Likelihood of Unwanted Event")
      },
      {
        dataField: 'new_financial',
        text: getText("Financial")
      },
      {
        dataField: 'new_safety',
        text: getText("Safety")
      },
      {
        dataField: 'new_health',
        text: getText("Occ. Health")
      },
      {
        dataField: 'new_reputation',
        text: getText("Reputation")
      },
      {
        dataField: 'new_environmental',
        text: getText("Environment")
      },
      {
        dataField: 'new_legal',
        text: getText("Legal")
      },
      {
        dataField: 'new_community',
        text: getText("Community")
      },
      {
        dataField: 'final_risk_rating',
        text: getText("Forecast Residual (Final) Risk Rating")
      },
      {
        dataField: 'actions',
        text: getText("1) Actions")
      },
      {
        dataField: 'manager',
        text: getText("2) Individual accountable for managing the specific Risk")
      },
      {
        dataField: 'effectiveness',
        text: getText("3) How is the effectiveness of Additional Controls verified?")
      },
      {
        dataField: 'status',
        text: getText("4) What is the status of the planned actions as well as their associated deliverable dates?")
      },
      {
        dataField: 'effectiveness2',
        text: getText("5) How is the effectiveness of the key controls verified?")
      }
    ];
  }

  getSixBySixExportOptions = () => {
    const { languageName } = this.props
    const riskColumns = getRiskColumnsByLanguage(languageName);
    return [
      {
        dataField: riskColumns.work_phase,
        text: getText("Work Phase or Ambient Exposure")
      },
      {
        dataField: riskColumns.activity,
        text: getText("Activity")
      },
      {
        dataField: riskColumns.hazard,
        text: getText("Hazard (Risk Source)")
      },
      {
        dataField: riskColumns.unwanted_event,
        text: getText("(Unwanted) Event")
      },
      {
        dataField: 'existing_preventative',
        text: getText("Existing Preventative Controls")
      },
      {
        dataField: 'existing_recovery',
        text: getText("Existing Recovery Controls")
      },
      {
        dataField: '6x6_likelihood',
        text: getText("Likelihood of Unwanted Event")
      },
      {
        dataField: 'consequences_description',
        text: getText("Consequence (text description)")
      },
      {
        dataField: '6x6_financial',
        text: getText("Financial")
      },
      {
        dataField: '6x6_safety',
        text: getText("Safety")
      },
      {
        dataField: '6x6_hygiene',
        text: getText("Hygiene")
      },
      {
        dataField: '6x6_reputation',
        text: getText("Reputation")
      },
      {
        dataField: '6x6_environmental',
        text: getText("Environment")
      },
      {
        dataField: '6x6_legal',
        text: getText("Legal")
      },
      {
        dataField: '6x6_community',
        text: getText("Community")
      },
      {
        dataField: '6x6_current_risk_rating',
        text: getText("Residual (Current) Risk Rating")
      },
      {
        dataField: 'additional_preventative',
        text: getText("Additional Preventative Controls")
      },
      {
        dataField: 'additional_recovery',
        text: getText("Additional Recovery Controls")
      },
      {
        dataField: '6x6_new_likelihood',
        text: getText("Likelihood of Unwanted Event")
      },
      {
        dataField: '6x6_new_financial',
        text: getText("Financial")
      },
      {
        dataField: '6x6_new_safety',
        text: getText("Safety")
      },
      {
        dataField: '6x6_new_hygiene',
        text: getText("Hygiene")
      },
      {
        dataField: '6x6_new_reputation',
        text: getText("Reputation")
      },
      {
        dataField: '6x6_new_environmental',
        text: getText("Environment")
      },
      {
        dataField: '6x6_new_legal',
        text: getText("Legal")
      },
      {
        dataField: '6x6_new_community',
        text: getText("Community")
      },
      {
        dataField: '6x6_final_risk_rating',
        text: getText("Forecast Residual (Final) Risk Rating")
      },
      {
        dataField: 'actions',
        text: getText("1) Actions")
      },
      {
        dataField: 'manager',
        text: getText("2) Individual accountable for managing the specific Risk")
      },
      {
        dataField: 'effectiveness',
        text: getText("3) How is the effectiveness of Additional Controls verified?")
      },
      {
        dataField: 'status',
        text: getText("4) What is the status of the planned actions as well as their associated deliverable dates?")
      },
      {
        dataField: 'effectiveness2',
        text: getText("5) How is the effectiveness of the key controls verified?")
      }
    ];
  }

  onChange = (evt, data) => {
    var columns = this.state.columns
    if (data.checked && !columns.includes(data.value)){
      columns.push(data.value)
    } else if (columns.includes(data.value)) {
      var index = columns.indexOf(data.value);
      if (index !== -1) columns.splice(index, 1);
    }
    this.setState({
      columns: columns
    })

  }

  onSelectAll = (evt) => {
    var columns = this.state.columns
    if (columns.length > 0) {
      columns = []
    }

    var options = this.getExportOptions();
    options.map((item, index)=>{
      columns.push(item.dataField);
      return true
    })
    this.setState({
      columns: columns
    })
  }

  onUnselectAll = (evt) => {
    this.setState({
      columns: []
    })
  }

  removePlanId = (plan_id) => {
    let { plan_ids } = this.state;
    plan_ids = plan_ids.filter(id => id !== plan_id);
    this.setState({ plan_ids });
  }

  render() {
    const { trigger, type, shown, onClose, pending, onExport, plans, isExportFailed, 
      exportingMessage = 'This may take a while so please wait.', 
      errorMessage = 'An error occurred while exporting.'
    } = this.props;
    const { export_to_excel, export_to_pdf, export_label, select_columns_for_export, select_all, unselect_all, export_descriptions } = this.props.translations
    const headerText = type === "Excel" ? export_to_excel : export_to_pdf;
    const options = this.getExportOptions();
    const optionsLeft = options.slice(0, 16)
    const optionsRight = options.slice(16)
    const { columns, plan_ids } = this.state;
    const selected_plans = plans ? plans.filter(plan => plan_ids.includes(plan.id) ) : [];

    return (
      <Modal className='export-modal' trigger={trigger} size="tiny" open={shown}>
        <Modal.Header>{headerText}</Modal.Header>
        <Modal.Content>
          <Form>
            {
              selected_plans && selected_plans.length > 0 &&
              <div className='export-descriptions'>
                <label>{export_descriptions}:</label>
                {
                  selected_plans.map((plan, index)=>{
                    return (<span className="badge">{plan.name} <i aria-hidden="true" className="delete icon" onClick={(evt)=>this.removePlanId(plan.id)}></i></span>)
                  })
                }
              </div>
            }
            <div className='sub-header-container'>
              <span className='sub-header'>{select_columns_for_export}</span>
              <span className='export-quick-actions'>
                <u onClick={this.onSelectAll}>{select_all}</u>
                <u onClick={this.onUnselectAll}>{unselect_all}</u>
              </span>
            </div>
            <div className='export-checkboxes'>
              {
                optionsLeft.map((item, index) => 
                  <Form.Checkbox key={index} label={item.text} value={item.dataField} onChange={this.onChange} checked={columns.includes(item.dataField)}/>
                )
              }
            </div>
            <div className='export-checkboxes'>
              {
                optionsRight.map((item, index) =>
                  <Form.Checkbox key={index} label={item.text} value={item.dataField} onChange={this.onChange} checked={columns.includes(item.dataField)}/>
                )
              }
            </div>
            {
              isExportFailed && (
                <div><Message color='red' className='export-error text-align-center'>{errorMessage}</Message></div>
              )
            }

          </Form>
        </Modal.Content>
        <Modal.Actions>
          { pending && <div className='export-loading-message'><span>{exportingMessage}</span></div> }
          <Button color='teal' disabled={columns.length === 0 || pending} fluid size='medium' onClick={(evt) => onExport(type, columns, plan_ids)} className="new-plan-button">{(pending) && <i className="loading circle notched icon"></i>} {export_label}</Button>
        </Modal.Actions>
        <i className="delete icon" onClick={onClose}></i>
      </Modal>
    )
  }
}

export default ExportModal



// WEBPACK FOOTER //
// ./src/components/export_modal/index.js